import { createSelector } from 'reselect';

import { getFilterParamsAdapter, getTimeFilterParams, getPaginationParams } from './../../api-adapter';
import { TESTS_PAGE_STATUSES } from '../../constants';

const testListStore = (store) => store.apps.analytics.testList;
const filtersStore = (store) => store.apps.analytics.filters;
const routerLocation = (store) => store.router.location;
export const testCasesParamsSelector = createSelector([
  filtersStore,
  testListStore,
  (store, options) => options,
], (filters, testList, options = {}) => {
  const { status } = options;
  return {
    ...getFilterParamsAdapter(filters.get('filters')),
    ...getTimeFilterParams(filters.get('selectedDateFilter')),
    ...getPaginationParams(testList.get('pagination')),
    ...(status && status !== TESTS_PAGE_STATUSES.inconsistent.status ? { status } : null),
  };
});

export const testListSelector = createSelector([
  testListStore,
], (testList) => ({
  loadingData: testList.get('loadingData'),
  pagination: testList.get('pagination'),
  testCases: testList.get('testCases'),
  testCasesCount: testList.get('testCasesCount'),
  sortField: testList.getIn(['sort', 'field']),
  sortDescending: testList.getIn(['sort', 'isDescending']),
}));

export const statusSelector = createSelector([
  routerLocation,
], (location) => {
  const splitPathname = location.pathname.split('/test-overview/tests/');
  return {
    status: splitPathname?.length > 1 ? splitPathname.pop() : null,
  };
});
